import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsJobJobDetailModel } from 'src/api/generated';

export const JOBS_URI = 'jobs';

export const jobsQueries = createQueryKeys(JOBS_URI, {
  all: null,
  detail: (jobId: string) => ({
    queryKey: [jobId],
    queryFn: async () => {
      const response = await get<FanguardApiContractsJobJobDetailModel>({ uri: `${JOBS_URI}/${jobId}` });
      return response.data;
    },
  }),
  once: (jobId: string) => ({
    queryKey: [jobId, 'once'],
    queryFn: async () => {
      const response = await get<FanguardApiContractsJobJobDetailModel>({ uri: `${JOBS_URI}/${jobId}` });
      return response.data;
    },
  }),
});
